import {DOT_PATTERN_BOUNDS,DOT_TILE_SIZE,normalizeDotPattern,dotPatternTile,dotFromId} from './dot-pattern.js';

export default function DotPattern({layer,prefix}) {
  const id=`${prefix}dots${layer.id}`,maskId=`${id}removed`,state=normalizeDotPattern(layer);
  const removed=state.erasedDots.map(dotFromId),bounds=DOT_PATTERN_BOUNDS;
  return <g data-dot-density={state.dotDensity} transform={state.dotFlipX?'translate(100 0) scale(-1 1)':undefined}>
    <defs>
      <pattern id={id} width={DOT_TILE_SIZE} height={DOT_TILE_SIZE} patternUnits="userSpaceOnUse">
        {dotPatternTile(state.dotDensity).flatMap((dot,index)=>(dot.x===0?[0,DOT_TILE_SIZE]:[dot.x]).flatMap(x=>(dot.y===0?[0,DOT_TILE_SIZE]:[dot.y]).map(y=><circle key={`${index}:${x}:${y}`} cx={x} cy={y} r={dot.r} fill={layer.color}/>)))}
      </pattern>
      {removed.length>0&&<mask id={maskId} maskUnits="userSpaceOnUse" {...bounds}>
        <rect {...bounds} fill="white"/>
        {removed.map(dot=><circle key={dot.id} cx={dot.x} cy={dot.y} r={dot.r+.15} fill="black"/>)}
      </mask>}
    </defs>
    <rect {...bounds} fill={`url(#${id})`} mask={removed.length?`url(#${maskId})`:undefined}/>
  </g>;
}
